export const configurationMenuUrl = "/configuration/";
